module.exports = __webpack_public_path__ + "img/item4.a97ab7ad.png";